import { gql } from '@apollo/client';

export const fetchSearchBasedAppsForProductsInPPCQuery = gql`
  query fetchSearchBasedAppsForProductsInPPC(
    $searchText: String
    $ids: [String]
    $pageParams: ProductPageParams
    $fetchPartnerPromotionStatus: Boolean = false
    $pricingPlanFilterOptions: [FilterOption]
    $filterOptions: [FilterOption]
  ) {
    availableAppsOnSearchBased(
      searchText: $searchText
      ids: $ids
      pageParams: $pageParams
      fetchPartnerPromotionStatus: $fetchPartnerPromotionStatus
      filterOptions: $filterOptions
    ) {
      nodes {
        id
        productKey
        status
        name: appName
        updatedDate
        offeringName
        pricingType
        pricingPlanKey
        trialLengthInDays
        logoId
        isAddOn
        isApp
        offeringId
        vendorName
        hasOptedInForPartnerPromotion @include(if: $fetchPartnerPromotionStatus)
        offering {
          id
          offeringName
          pricingType
          offeringGroup
          relationshipRequirements {
            level
            side
            type
          }
          availablePricingPlans(filterOptions: $pricingPlanFilterOptions) {
            type
            id
            currency
            pricingPlanType
            status
            description
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
